import { render, staticRenderFns } from "./FootprintTableSingleEdit.vue?vue&type=template&id=3052fb41&"
import script from "./FootprintTableSingleEdit.vue?vue&type=script&lang=js&"
export * from "./FootprintTableSingleEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports